// import { get, post } from './http'
import { get, post, postForm, put, putForm, del, upload } from './request'

var $api = []

//地址管理-获取省市区
$api.getConcat = params => get('/api/api-fe/api-addr-nl/provinces', params)
//地址管理-获取省
$api.getProvinces = params => get('/api/api-fe/api-addr/admin/provinces', params)

// 登录
$api.login = params => get('/api/slm/admin', params)
// 登录获取个人信息
$api.logingca = params => get('/api/api-smc/admin/aca/gca', params)
// 测试
$api.test = params => get('/api/api-smc/api/students', params)

//用户列表
$api.userList = params => get('/api/api-u/admin/user/afp', params)

//用户列表-账号封禁
$api.banList = (params, endTime, cause) => put(`/api/api-u/admin/user/ban?uid=${params}&endTime=${endTime}&cause=${cause}`)

//解禁
$api.closeBan = params => putForm(`/api/api-u/admin/user/ban-cancel/${params}`)

//用户详情
$api.detailUser = params => get(`/api/api-u/admin/user/detail/${params}`)

//用户列表-报名人信息
$api.banInfo = params => get(`/api/api-smc/admin/user-contacts/list/${params}`)

//修改个人信息--------
$api.setInfo = (params) => post('/api/api-smc/admin/aca/sou', params)

//用户列表-报名人信息修改
$api.infoEdit = params => post('/api/api-smc/admin/user-contacts/edit', params)

//用户注销/申请列表
$api.alrList = params => get('/api/api-u/admin/alr/page', params)

//钱包管理-钱包汇总
$api.summaryList = params => get('/api/api-pay/admin/wallet/summary', params)

//钱包管理-钱包列表
$api.walletList = params => get('/api/api-pay/admin/wallet/wrs', params)

//钱包管理-冻结/解冻
$api.walletfuf = params => post(`/api/api-pay/admin/wallet/fuf/${params}`)

//钱包列表-绑定账户
$api.walletfbaList = params => get(`/api/api-pay/admin/wallet/fba/${params}`)

//钱包列表-充值/扣除金额
$api.walletwr = (addition, amount, reason, remark, wid) => post(`/api/api-pay/admin/wallet/wr?addition=${addition}&amount=${amount}&reason=${reason}&remark=${remark}&wid=${wid}`)

//钱包列表-后台管理员开通钱包
$api.walletOpen = (params) => post(`/api/api-pay/admin/wallet/cow?phone=${params}`)

//钱包管理-钱包流水
$api.walletwarList = params => get('/api/api-pay/admin/wallet/war', params)

//钱包管理-钱包流水 提现详情
$api.walletwarDetail = params => get(`/api/api-pay/admin/wallet/rwa-detail/${params}`)

//钱包管理-钱包流水-提现通过/拒绝
$api.walletwva = (id, params, applyAmount, balance, remark, title) => post(`/api/api-pay/admin/wallet/wva?id=${id}&adopt=${params}&adopt=${applyAmount}&balance=${balance}&remark=${remark}&title=${title}`)
// $api.walletwva = params => post('/api/api-pay/admin/wallet/wva', params)

//字典列表接口
$api.dictList = params => get('/api/api-smc/admin/dict/list', params)

/* 添加或更新条款、须知、声明 */
$api.addTerms = params => post('/api/api-smc/admin/template/sou', params)

/* 获取条款、须知、声明列表 */
$api.getTerms = params => get('/api/api-smc/admin/template/page', params)

/* 获取系列赛标签*/
$api.getTags = params => get('/api/api-smc/admin/mh-classify/page', params)

//新增系列赛标签
$api.addTags = params => post('/api/api-smc/admin/mh-classify/sou', params)

//删除系列赛标签
$api.delTags = params => del(`/api/api-smc/admin/mh-classify/del/${params}`)

//发布赛事
$api.addEvent = params => post('/api/api-smc/admin/mh/sou', params)

//添加/编辑项目
$api.addEntries = params => post('/api/api-smc/admin/entries/sou', params)

/* 发布赛事 - 添加项目 - 获取报名方式列表 */
$api.getRegistrationWay = params => get('/api/api-smc/admin/dict/list', params)

//[赛事列表]
$api.eventList = params => get('/api/api-smc/admin/mh/page', params)

//赛事列表=>赛事列表导出
$api.exportList = params => get('/api/api-smc/admin/mh/export-data')

//赛事列表=>赛事列表排序
$api.assList = (params, id, self) => post(`/api/api-smc/admin/mh/ass?direction=${params}&id=${id}&self=${self}`)

//赛事列表=>发布或取消发布赛事
$api.publishedCancel = params => post(`/api/api-smc/admin/mh/publish/${params}`)

//赛事列表=>取消赛事或恢复赛事
$api.restoreCancal = (params, id) => post(`/api/api-smc/admin/mh/acm?delay=${params}&id=${id}`)

//赛事列表=>取消延期或赛事延期
$api.delayCancal = (params, id) => post(`/api/api-smc/admin/mh/adm?delay=${params}&id=${id}`)

//赛事列表=>赛事项目详情
$api.entriesInfo = params => get(`/api/api-smc/admin/entries/${params}`)

//赛事列表=>删除赛事
$api.delList = params => del(`/api/api-smc/admin/mh/del/${params}`)

//发布或取消发布赛事
// $api.publish = params => post('/api/admin//publish/{id}', params)

//赛事列表=>获取赛事详情
$api.eventDetail = params => get(`/api/api-smc/admin/mh/detail/${params}`)

//赛事列表=>删除赛事
$api.delEvent = params => del('/api/api-smc/admin/mh/del/2', params)

//赛事列表-赛事项目列表
$api.projectList = params => get('/api/api-smc/admin/entries/page', params)

//赛事列表-赛事项目-表单列表
$api.FormList = (params, id) => get(`/api/api-smc/admin/entries/forms/${params}/${id}`)

//赛事列表-赛事项目-表单列表-表单子value值编辑
$api.FormAdd = (params, values) => post(`/api/api-smc/admin/entries/forms-value/update?id=${params}&values=${values}`)

//赛事列表-赛事项目列表=>添加赛事项目
$api.addProject = params => post('/api/api-smc/admin/entries/sou', params)

//赛事列表-赛事项目列表=>增值服务项目 
$api.adsList = params => get('/api/api-smc/admin/ads/list', params)

//增值服务项目（赛事服务项）-列表
$api.adsPage = params => get('/api/api-smc/admin/ads/page', params)

//增值服务项目（赛事服务项）-新增/编辑
$api.addAds = params => post('/api/api-smc/admin/ads/sou', params)

//增值服务详情
$api.adsDetail = params => get(`/api/api-smc/admin/ads/detail/${params}`)

//删除增值服务
$api.delAds = params => del(`/api/api-smc/admin/ads/del/${params}`)

//赛事列表-赛事项目=>新增/编辑增值服务项目
$api.addPage = params => post('/api/api-smc/admin/ads/sou', params)

//赛事列表-赛事项目=>新增/编辑表单项
$api.addForm = params => post('/api/api-smc/admin/d-form/sou', params)

//赛事列表-赛事项目=>获取动态表单详情
$api.detailForm = params => get(`/api/api-smc/admin/d-form/detail/${params}`)

//赛事列表-赛事项目详情
$api.entriesDetail = params => get(`/api/api-smc/admin/entries/detail/${params}`)

//赛事列表-赛事项目报名开关
$api.entriesFlag = params => post(`/api/api-smc/admin/entries/co/${params}`)

//赛事列表-赛事项目删除项目
$api.delEntries = params => post(`/api/api-smc/admin/entries/del/${params}`)

//赛事列表-赛事项目排序
$api.entriesAss = (params, id) => post(`/api/api-smc/admin/entries/ass?direction=${params}&id=${id}`)

//获取简单赛事列表--条件查询时用
$api.searchEvent = params => get('/api/api-smc/admin/mh/afsm', params)

//获取简单赛事项目列表--条件查询时用
$api.searchProject = params => get(`/api/api-smc/admin/entries/afse/${params}`)

//报名管理列表
$api.signList = params => get('/api/api-smc/admin/mo-ods/list', params)

//报名管理列表-修改订单状态
$api.editStatusList = (id, params) => put(`/api/api-smc/admin/mo-ods/mos?id=${id}&state=${params}`)

//报名管理-获取赛事订单下的报名用户列表
$api.detailUsers = params => get(`/api/api-smc/admin/mo-ods/users/${params}`)

//报名管理-获取子订单详情
$api.detailSub = params => get('/api/api-smc/admin/mh-ods/u-sub-detail', params)

//报名管理-获取子订单详情修改
$api.editSub = params => post('/api/api-smc/admin/mh-ods/u-update-sub', params)

//报名管理-导入参赛号
$api.importRn = params => upload('/api/api-smc/admin/mo-ods/import-rn', params)

//报名管理-批量更改状态
$api.importRn1 = params => upload('/api/api-smc/admin/mo-ods/import-os', params)

//报名管理-导入抽签
$api.importRn2 = params => upload('/api/api-smc/admin/mo-ods/import-dl', params)

// $api.importRn3 = params => upload('/api/api-smc/admin/mo-ods/import-dl', params)

//报名管理-预退款
$api.refund = params => get('/api/api-smc/admin/mh-ods/pre-refund', params)

//报名管理-子订单预退款
$api.refundSub = params => get('/api/api-smc/admin/mh-ods/pre-sub-refund', params)

//报名管理-退款
$api.yesRefund = (odId, amount, refundType, reason, subOdId) => postForm(`/api/api-smc/admin/mh-ods/refund?odId=${odId}&refundAll=true&amount=${amount}&refundType=${refundType}&reason=${reason}&subOdId=${subOdId}`)

//报名管理-导出各种模版
$api.importTemplate = params => get('/api/api-smc/admin/mo-ods/export-tf', params)

//报名管理-导出并提交
$api.importSubmit = params => get('/api/api-smc/admin/mo-ods/export-submit-data', params)

//报名管理-详情
$api.detailOds = params => get(`/api/api-smc/admin/mo-ods/detail/${params}`)

//报名管理-修改订单状态 
$api.editType = params => post('/api/api-smc/admin/mo-ods/import-os', params)

//报名表单项-列表
$api.dformList = params => get('/api/api-smc/admin/d-form/page', params)

//报名表单项-新增/编辑
$api.addDform = params => post('/api/api-smc/admin/d-form/sou', params)

//报名表单项-校验是否有重复的column
$api.accform = params => get('/api/api-smc/admin/d-form/acc', params)

//报名表单项-排序
$api.assForm = (params, id) => post(`/api/api-smc/admin/d-form/ass?direction=${params}&id=${id}`)

//报名表单项-删除
$api.delForm = params => del(`/api/api-smc/admin/d-form/del/${params}`)

//报名表单项-详情
$api.detailDForm = params => get(`/api/api-smc/admin/d-form/detail/${params}`)

//条款须知列表
$api.templateList = params => get('/api/api-smc/admin/template/page', params)

//条款须知列表-编辑/新增
$api.addTemplate = params => post('/api/api-smc/admin/template/sou', params)

//条款须知列表-详情
$api.detailTemplate = params => get(`/api/api-smc/admin/template/detail/${params}`)

//条款须知-删除
$api.delTemplate = params => del(`/api/api-smc/admin/template/del/${params}`)

//协议列表
$api.findsList = params => get('/api/api-smc/admin/app-at/finds', params)

//协议列表-编辑/新增
$api.addFinds = params => post('/api/api-smc/admin/app-at/sou', params)

//协议列表-详情
$api.detailFinds = params => get(`/api/api-smc/admin/app-at/finds/rich-text/${params}`)

//协议列表-删除
$api.delFinds = params => del(`/api/api-smc/admin/app-at/del/${params}`)

//黑名单管理列表
$api.blackList = params => get('/api/api-smc/admin/blacklist/page', params)

//黑名单管理-导入
$api.importBl = params => upload('/api/api-smc/admin/blacklist/import-bl', params)

//黑名单管理-添加
$api.addBlack = params => post('/api/api-smc/admin/blacklist/sou', params)

//黑名单管理-移除
$api.delBlack = params => del(`/api/api-smc/admin/blacklist/del/${params}`)

//邀请码列表
$api.codeList = params => get('/api/api-smc/admin/invite-code/page', params)

//邀请码生成
$api.addCode = params => post('/api/api-smc/admin/invite-code/generate', params)

//邀请码删除
$api.delCode = params => del(`/api/api-smc/admin/invite-code/del?ids=${params}`)

//意见反馈列表
$api.feedbackList = params => get('/api/api-smc/admin/feedback/page', params)

//意见反馈回复
$api.replyFeedback = (params, id) => put(`/api/api-smc/admin/feedback/reply?content=${params}&id=${id}`)

//创建单个文件目录
$api.createAlbum = params => post('/api/api-fe/api-file/album/create', params)

//更新目录名称
$api.updateAlbum = params => post('/api/api-fe/api-file/album/update', params)

//删除单个目录
$api.delAlbum = params => del('/api/api-fe/api-file/album/del/{id}', params)

//删除单个文件
$api.delFile = params => del('/api/api-fe/api-file/album/file-del/{id}', params)

//删除多个文件
$api.delFiles = params => postForm(`/api/api-fe/api-file/album/files-del?ids=${params}`)

//获取文件目录里的文件
$api.albums = params => get('/api/api-fe/api-file/albums', params)

//根据商户获取文件目录
$api.mainAlbum = params => get('/api/api-fe/api-file/albums/{id}', params)

//字典管理列表
$api.dictPage = params => get('/api/api-smc/admin/dict/page', params)

//字典管理-添加
$api.addDict = params => post('/api/api-smc/admin/dict/sou', params)

//字典管理-删除
$api.delDict = params => del(`/api/api-smc/admin/dict/del/${params}`)

//菜单管理列表
$api.menuPage = params => get('/api/api-smc/admin/menu/list', params)

//简单菜单列表
$api.menuFsm = params => get('/api/api-smc/admin/menu/fsm', params)

//菜单排序
$api.assMenu = (id, params) => post(`/api/api-smc/admin/menu/ass?id=${id}&direction=${params}`)

//登陆菜单列表
$api.menuLogin = params => get('/api/api-smc/admin/login-sus/menus', params)

//添加主菜单/子菜单
$api.addMenu = params => post('/api/api-smc/admin/menu/sou', params)

//添加菜单权限
$api.addPermission = params => post('/api/api-smc/admin/menu-permission/sou', params)

//菜单管理删除
$api.delMenu = params => del(`/api/api-smc/admin/menu/del/${params}`)

//菜单管理权限列表删除
$api.delPermission = params => del(`/api/api-smc/admin/menu-permission/del/${params}`)

//后台账号管理列表
$api.ausPage = params => get('/api/api-smc/admin/aus/page', params)

//添加后台账号
$api.addAus = params => post('/api/api-smc/admin/aus/sou', params)

//删除后台账号
$api.delAus = params => del(`/api/api-smc/admin/aus/del/${params}`)

//后台账号详情
$api.detailAus = params => get(`/api/api-smc/admin/aus/detail/${params}`)

//后台账号重置密码
$api.resetPwdAus = params => post(`/api/api-smc/admin/aus/reset-pwd?id=${params}`)

//角色列表
$api.asrPage = params => get('/api/api-smc/admin/asr/page', params)

//添加/编辑角色
$api.addAsr = params => post('/api/api-smc/admin/asr/sou', params)

//删除角色
$api.delAsr = params => del(`/api/api-smc/admin/asr/del/${params}`)

//角色详情
$api.detailAsr = params => get(`/api/api-smc/admin/asr/detail/${params}`)

//举报管理列表
$api.rcPage = params => get('/api/api-smc/admin/rc/page', params)

//举报管理列表/封禁||已读
$api.rcBan = (id, params) => put(`/api/api-smc/admin/rc/ban-read?id=${id}&ban=${params}`)

//推送管理列表
$api.pushPage = params => get('/api/api-smc/admin/push/page', params)

//推送管理-新增
$api.addPush = params => post('/api/api-smc/admin/push/sou', params)

//推送管理-取消推送
$api.cancelPush = params => post(`/api/api-smc/admin/push/cancel/${params}`)

//推送管理-删除推送
$api.delPush = params => post(`/api/api-smc/admin/push/del/${params}`)

//banner列表
$api.bannerPage = params => get('/api/api-smc/admin/banner/page', params)

//新增/编辑banner
$api.addBanner = params => post('/api/api-smc/admin/banner/sou', params)

//banner排序
$api.assBanner = (params, id) => post(`/api/api-smc/admin/banner/ass?direction=${params}&id=${id}`)

//banner删除
$api.delBanner = params => del(`/api/api-smc/admin/banner/del/${params}`)

//banner详情
$api.detailBanner = params => get(`/api/api-smc/admin/banner/detail/${params}`)

//banner开关
$api.ocbBanner = params => post(`/api/api-smc/admin/banner/ocb?id=${params}`)

//报名审核列表
$api.affPage = params => get('/api/api-smc/admin/mo-aff/page', params)

//报名审核列表通过/拒绝
$api.araPage = (params) => post('/api/api-smc/admin/mo-vupr/ara', params)

//报名审核详情
$api.detailAff = params => get(`/api/api-smc/admin/mo-aff/detail/${params}`)

//退款审核
$api.odsPage = params => get('/api/api-smc/admin/mo-ods/rar', params)

//退款审核-通过/拒绝
$api.odsPass = (id, params, cause) => post(`/api/api-smc/admin/mh-ods/refund/rav?odId=${id}&pass=${params}&cause=${cause}`)

//退款详情
$api.odsDetail = (params) => get(`/api/api-smc/admin/mo-ods/rad/${params}`)

//退款详情用户购买的增值服务
$api.odsGa = (params) => get(`/api/api-smc/admin/mo-ods/ga/${params}`)

//中台赛事审核
$api.otePage = params => get('/api/api-smc/admin/mh-ote/page', params)

//中台赛事审核通过
$api.AcaOte = params => postForm('/api/api-smc/admin/mh-ote/aca', params)

//中台赛事审核拒绝
$api.AraOte = params => postForm('/api/api-smc/admin/mh-ote/ara', params)

//中台赛事详情
$api.detailOte = params => get(`/api/api-smc/admin/mh-ote/detail/${params}`)

//新闻栏目列表
$api.amsList = params => get('/api/api-smc/admin/ams/list', params)

//新闻栏目新增/编辑
$api.amsAdd = params => post('/api/api-smc/admin/ams/sou', params)

//新闻栏目删除
$api.delAms = params => del(`/api/api-smc/admin/ams/del/${params}`)

//新闻内容列表
$api.articleList = params => get('/api/api-smc/admin/article/page', params)

//新闻评论状态开关
$api.aeccfArticle = params => post(`/api/api-smc/admin/article/aeccf?id=${params}`)

//添加新闻
$api.amsArticle = params => post('/api/api-smc/admin/article/sou', params)

//新闻前端是否可展示
$api.asdArticle = params => post(`/api/api-smc/admin/article/asd?id=${params}`)

//新闻删除
$api.delArticle = params => del(`/api/api-smc/admin/article/del/${params}`)

//新闻排序
$api.assArticle = (params, direction) => post(`/api/api-smc/admin/article/ass?id=${params}&direction=${direction}`)

//新闻详情
$api.detailArticle = params => get(`/api/api-smc/admin/article/detail/${params}`)

/* 上传图片 */
$api.fileUpload = params => upload('/api/api-fe/api-file/upload/aliyun', params)

// 逆地址解析 - 测试
$api.geo = params => get('https://restapi.amap.com/v3/geocode/geo', params)

// 上传图片
$api.upload = params => upload('https://gateway.qoqq.com/api-f/files/upload', params)

//播报管理-配置
$api.broadcastConfig = params => get('/api/api-smc/admin/bcc/config', params)

//播报管理-新增配置
$api.broadcastConfigAdd = params => post('/api/api-smc/admin/bcc/sou', params)

//播报管理-删除配置
$api.broadcastConfigDel = params => del(`/api/api-smc/admin/bcc/adc/${params}`)

//播报管理-广播信息
$api.broadcast = params => get('/api/api-smc/admin/bcr/records', params)

//播报管理-广播信息删除
$api.broadcastDel = params => del(`/api/api-smc/admin/bcr/adc/${params}`)

//播报管理-广播信息添加
$api.broadcastAdd = params => post('/api/api-smc/admin/bcr/sou', params)

//订单中心
$api.orderList = params => get('/api/api-pay/admin/unified-order/ors', params)

//问答列表
$api.qasList = params => get('/api/api-smc/admin/qas/list', params)

//问答-新增
$api.qasAdd = params => post('/api/api-smc/admin/qas/sou', params)

//问答-删除

$api.qasDel = params => del(`/api/api-smc/admin/qas/del/${params}`)



export { $api }
